import { render, staticRenderFns } from "./LoadFromDraftModal.vue?vue&type=template&id=81a33530&scoped=true"
import script from "./LoadFromDraftModal.vue?vue&type=script&lang=js"
export * from "./LoadFromDraftModal.vue?vue&type=script&lang=js"
import style0 from "./LoadFromDraftModal.vue?vue&type=style&index=0&id=81a33530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a33530",
  null
  
)

export default component.exports